import type { MonospaceWorkspace } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';
import { SystemMonospaceFile } from './file';

const WORKSPACE_DATETIME_FIELDS = ['dateCreated', 'dateUpdated'] as const;

export const Workspace = RStoreSchema.withItemType<MonospaceWorkspace>().defineCollection({
	getKey: (item) => item.apiName ?? item.id,
	name: 'MonospaceWorkspace',
	scopeId: 'monospace-default',
	fields: defineSystemDateTimeFields(WORKSPACE_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'apiName',
			'displayName',
			'description',
			'defaultLanguage',
			'logoId',
			'primaryColor',
			'apiNamingConvention',
			'dbNamingConvention',
			'dateCreated',
			'dateUpdated',
		],
		endpoint: 'system/workspaces',
		fetchOnCreate: true,
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(WORKSPACE_DATETIME_FIELDS),
	},
});

export const SystemWorkspaceRelations = RStoreSchema.defineRelations(Workspace, ({ collection }) => ({
	logo: {
		to: collection(SystemMonospaceFile, {
			on: {
				'SystemMonospaceFile.id': 'MonospaceWorkspace.logoId',
			},
		}),
	},
}));
